export default __webpack_public_path__ + "static/media/ppt.220ea7a8.svg";